var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portal',{attrs:{"to":"breadcrumbs"}},[_c('ul',{staticClass:"breadcrumb breadcrumb-transparent font-weight-bold p-0 my-2 font-size-sm"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }